// Fixed custom rate: 1 USD = 290 PKR
(function(){
  const RATE_USD_PER_PKR = 1/290;
  const STORAGE_KEY = 'skydeep_currency';
  let isUpdating = false; // Prevent infinite loop

  function formatUSD(pkr){ 
    const usd = (Number(pkr) * RATE_USD_PER_PKR) || 0; 
    return `$${usd.toFixed(2)} USD`; 
  }
  
  function formatPKR(pkr){ 
    const v = Number(pkr) || 0; 
    return `Rs ${v.toLocaleString('en-PK')}`; 
  }

  function getPKRFromEl(el){
    if(el.dataset.pricePkr) return parseFloat(el.dataset.pricePkr);
    if(el.dataset.priceMinPkr) return parseFloat(el.dataset.priceMinPkr);
    return null;
  }

  function updatePrices(currency){
    if(isUpdating) return; // Prevent re-entry
    isUpdating = true;
    
    document.querySelectorAll('.price-display').forEach(el=>{
      const pkr = getPKRFromEl(el);
      if(pkr == null || isNaN(pkr)) return;
      
      // Only update if currency actually changed
      if(el.dataset.currency !== currency){
        el.textContent = (currency === 'USD') ? formatUSD(pkr) : formatPKR(pkr);
        el.dataset.currency = currency;
      }
    });
    
    localStorage.setItem(STORAGE_KEY, currency);
    isUpdating = false;
  }

  document.addEventListener('click', e=>{
    const btn = e.target.closest('.js-currency-btn');
    if(btn && btn.dataset.c){ 
      updatePrices(btn.dataset.c); 
    }
  });

  // React to theme dynamic updates (variant change, quick view, etc.)
  const obs = new MutationObserver((mutations)=> {
    if(isUpdating) return; // Ignore mutations we're causing
    
    // Only process if new .price-display elements were added
    let hasNewPriceElements = false;
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if(node.nodeType === 1){ // Element node
          if(node.classList?.contains('price-display') || 
             node.querySelector?.('.price-display')){
            hasNewPriceElements = true;
          }
        }
      });
    });
    
    if(hasNewPriceElements){
      const c = localStorage.getItem(STORAGE_KEY) || 'PKR';
      updatePrices(c);
    }
  });
  
  obs.observe(document.documentElement, { childList:true, subtree:true });

  // Initial
  updatePrices(localStorage.getItem(STORAGE_KEY) || 'PKR');
})();